var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackSight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.014,
    height: 37.124,
    viewBox: "0 0 32.014 37.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21640",
    "data-name": "\\uADF8\\uB8F9 21640",
    transform: "translate(0.85 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10228",
    "data-name": "\\uD328\\uC2A4 10228",
    d: "M436.892,153.278a12.924,12.924,0,0,1,22.078.278",
    transform: "translate(-432.899 -147.212)",
    fill: "none",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10229",
    "data-name": "\\uD328\\uC2A4 10229",
    d: "M443.061,154.314a5.5,5.5,0,0,1,9.4.118",
    transform: "translate(-432.729 -147.087)",
    fill: "none",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10230",
    "data-name": "\\uD328\\uC2A4 10230",
    d: "M460.738,179.279H435.345a1.838,1.838,0,0,1-1.881-1.79v-8.355a1.972,1.972,0,0,1,.552-1.322,2.942,2.942,0,0,1,2.207-.917h23.638a2.944,2.944,0,0,1,2.207.917,1.971,1.971,0,0,1,.551,1.322v8.355A1.837,1.837,0,0,1,460.738,179.279Z",
    transform: "translate(-432.993 -146.669)",
    fill: "none",
    stroke: "#212529",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10231",
    "data-name": "\\uD328\\uC2A4 10231",
    d: "M461.153,167.123H435.447l3.266-7.347a1.88,1.88,0,0,1,1.718-1.117h15.739a1.881,1.881,0,0,1,1.718,1.117Z",
    transform: "translate(-432.939 -146.896)",
    fill: "none",
    stroke: "#212529",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10232",
    "data-name": "\\uD328\\uC2A4 10232",
    d: "M435.357,164.376H433.79c-.434,0-.784-.5-.784-1.126s.35-1.125.784-1.125h2.838l-.7,2.251Z",
    transform: "translate(-433.006 -146.801)",
    fill: "none",
    stroke: "#212529",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10233",
    "data-name": "\\uD328\\uC2A4 10233",
    d: "M460.252,164.376h1.567c.434,0,.784-.5.784-1.126s-.35-1.125-.784-1.125h-2.838l.7,2.251Z",
    transform: "translate(-432.289 -146.801)",
    fill: "none",
    stroke: "#212529",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10234",
    "data-name": "\\uD328\\uC2A4 10234",
    d: "M441.235,172.991a1.591,1.591,0,1,1-1.592-1.592A1.592,1.592,0,0,1,441.235,172.991Z",
    transform: "translate(-432.867 -146.545)",
    fill: "none",
    stroke: "#212529",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10235",
    "data-name": "\\uD328\\uC2A4 10235",
    d: "M456.748,172.991a1.591,1.591,0,1,1-1.592-1.592A1.592,1.592,0,0,1,456.748,172.991Z",
    transform: "translate(-432.439 -146.545)",
    fill: "none",
    stroke: "#212529",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28087",
    "data-name": "\\uC0AC\\uAC01\\uD615 28087",
    width: 5.643,
    height: 2.508,
    rx: 0.416,
    transform: "translate(3.763 32.765)",
    fill: "none",
    stroke: "#212529",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28088",
    "data-name": "\\uC0AC\\uAC01\\uD615 28088",
    width: 5.643,
    height: 2.508,
    rx: 0.416,
    transform: "translate(20.142 32.765)",
    fill: "none",
    stroke: "#212529",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackSight);
export default __webpack_public_path__ + "static/media/BackSight.dc270bfb25aba057cb0283450f755e7d.svg";
export { ForwardRef as ReactComponent };